import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

const S = {
  page: { minHeight: '100vh', background: '#0a0a0a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', fontFamily: "'Inter', sans-serif" },
  card: { width: '100%', maxWidth: '440px', background: '#111', border: '1px solid #222', borderRadius: '8px', padding: '2.5rem' },
  title: { color: '#e0e0e0', fontSize: '1.3rem', fontWeight: 600, marginBottom: '0.4rem', fontFamily: "'Merriweather', serif" },
  subtitle: { color: '#bbb', fontSize: '0.88rem', marginBottom: '2rem', lineHeight: '1.6' },
  label: { display: 'block', color: '#bbb', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.35rem' },
  input: { width: '100%', background: '#0a0a0a', border: '1px solid #2a2a2a', borderRadius: '4px', color: '#e0e0e0', padding: '0.65rem 0.8rem', fontSize: '0.95rem', boxSizing: 'border-box', marginBottom: '1.2rem', outline: 'none' },
  btn: { width: '100%', background: '#8B1A1A', color: '#fff', border: 'none', borderRadius: '4px', padding: '0.75rem', fontSize: '0.95rem', fontWeight: 600, cursor: 'pointer', letterSpacing: '0.04em' },
  btnDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  error: { color: '#e74c3c', fontSize: '0.85rem', marginBottom: '1rem' },
  confirm: { background: '#111', border: '1px solid #2a2a2a', borderRadius: '6px', padding: '1.2rem', textAlign: 'center', color: '#B8860B', fontSize: '0.95rem', lineHeight: '1.6' },
}

export default function Login() {
  const { login } = useAuth()
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState('idle')
  const [error, setError] = useState('')

  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!valid) return
    setStatus('submitting')
    setError('')
    try {
      await login(email)
      setStatus('sent')
    } catch (err) {
      setError(err.response?.data?.error || 'Unable to send login link. Please check your email address.')
      setStatus('idle')
    }
  }

  if (status === 'sent') {
    return (
      <div style={S.page}>
        <div style={S.card}>
          <div style={S.title}>Check your email</div>
          <div style={{ ...S.confirm, marginTop: '1.5rem' }}>
            <p>A secure access link has been sent to:</p>
            <p style={{ marginTop: '0.5rem', color: '#e0e0e0', fontWeight: 500 }}>{email}</p>
            <p style={{ marginTop: '0.75rem', color: '#bbb', fontSize: '0.83rem' }}>
              The link expires in 15 minutes. Check your spam folder if you don't see it.
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.title}>Sign In</div>
        <div style={S.subtitle}>
          We'll send you a secure access link. No password needed.
        </div>

        {error && <div style={S.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={S.label}>Email Address</label>
          <input
            style={S.input}
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="email"
            placeholder="you@example.com"
          />

          <button
            type="submit"
            style={{ ...S.btn, ...((!valid || status === 'submitting') ? S.btnDisabled : {}) }}
            disabled={!valid || status === 'submitting'}
          >
            {status === 'submitting' ? 'Sending...' : 'Send Access Link'}
          </button>
        </form>
      </div>
    </div>
  )
}
